import { render, staticRenderFns } from "./categories-widget.component.vue?vue&type=template&id=1fd04136&scoped=true"
import script from "./categories-widget.component.vue?vue&type=script&lang=ts"
export * from "./categories-widget.component.vue?vue&type=script&lang=ts"
import style0 from "./categories-widget.component.vue?vue&type=style&index=0&id=1fd04136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd04136",
  null
  
)

export default component.exports